import {InitialState} from "./state";

export const DICT_ROLES = "DICT_ROLES";


export function navigated(id) {
    return {
        type: DICT_ROLES,
        reduce: (_state) => ({
            ...InitialState,
            id
        })
    }
}

export function operationPending() {
    return {
        type: DICT_ROLES,
        reduce: (state) => ({
            ...state,
            viewState: 0,
        })
    }
}

export function operationComplete(viewState = 200) {
    return {
        type: DICT_ROLES,
        reduce: (state) => ({
            ...state,
            viewState: viewState,
        })
    }
}

export function receiveListSuccess(list) {
    return {
        type: DICT_ROLES,
        reduce: (state) => ({
            ...state,
            list,
            listLoaded: true,
        })
    }
}

